<div
  class="layout-wrapper bg-white dark:bg-primary-900"
  [ngClass]="'var->containerClass'"
>
  <div class="layout-topbar fixed w-full z-1000">
    <p-menubar class="h-16">
      <ng-template #start>
        <div
          class="flex items-center gap-2 max-w-59 pr-1 transition"
          [ngClass]="{
            'justify-between': logoTemplate || logoSrc(),
            'justify-end': !logoTemplate && !logoSrc(),
            '-translate-x-49': !logoTemplate && !logoSrc() && !sidebarVisible(),
          }"
        >
          <ng-container [ngTemplateOutlet]="logoTemplate"></ng-container>
          @if (!logoTemplate && logoSrc()) {
            <img class="h-8" [src]="logoSrc()" alt="logo" />
          }

          @if (showToggle() && sidebarEnabled()) {
            <p-button
              [rounded]="true"
              [text]="true"
              [icon]="
                'fa-regular fa-chevrons-right transition duration-250 ' +
                (sidebarVisible() ? 'rotate-180' : '')
              "
              severity="contrast"
              (onClick)="toggleSidebar()"
            ></p-button>
          }
        </div>
      </ng-template>
      <ng-template #end>
        <ng-container [ngTemplateOutlet]="toolbarTemplate"></ng-container>
      </ng-template>
    </p-menubar>
  </div>
  <div
    class="py-5 layout-sidebar top-16 fixed h-[calc(100%-var(--spacing)*16)] transition"
    [ngClass]="{
      '-translate-x-full': !sidebarVisible() || !sidebarEnabled(),
      'left-0': sidebarVisible() && sidebarEnabled(),
    }"
  >
    @if (sidebarHeaderTemplate) {
      <ng-container [ngTemplateOutlet]="sidebarHeaderTemplate"></ng-container>
    }
    <p-panel-menu
      styleClass="w-60 h-full"
      [multiple]="true"
      [model]="navItems()"
    ></p-panel-menu>
    @if (sidebarFooterTemplate) {
      <ng-container [ngTemplateOutlet]="sidebarFooterTemplate"></ng-container>
    }
  </div>
  <div
    class="layout-main-container pt-16 flex flex-col space-between transition-[margin-left] min-h-[100vh]"
    [ngClass]="{
      'ml-60': sidebarVisible() && sidebarEnabled(),
      'ml-0': !sidebarVisible() || !sidebarEnabled(),
    }"
  >
    <div class="@container layout-main grow shrink basis-auto">
      <div class="px-5 py-8 @5xl:px-18">
        @if (breadCrumbs().length || breadcrumbActionsTemplate) {
          <div class="flex gap-1 items-center justify-between mb-2 flex-wrap">
            @if (breadCrumbs().length) {
              <p-breadcrumb [model]="breadCrumbs()" [home]="homeCrumb()">
                <ng-template #item let-item>
                  @if (item.routerLink) {
                    <a [routerLink]="item.routerLink">{{
                      item.label | translate
                    }}</a>
                  } @else {
                    <span>{{ item.label | translate }}</span>
                  }
                </ng-template>
              </p-breadcrumb>
            }
            @if (breadcrumbActionsTemplate) {
              <ng-container
                [ngTemplateOutlet]="breadcrumbActionsTemplate"
              ></ng-container>
            }
          </div>
        }
        <router-outlet
          #outlet="outlet"
          (activate)="routeActivated(outlet)"
        ></router-outlet>
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
    @if (!footerTemplate && footerText()) {
      <div
        class="layout-footer flex align-center justify-center px-4 py-4 gap-2"
      >
        <div class="footer-content" [innerHTML]="footerText()"></div>
      </div>
    }
  </div>
</div>
